import React from 'react';
import styles from 'styles/components/navigation/navBar.css';
import { NavMain, NavComparison, NavTable, HamburgerButton, CloseBtn } from 'components/lib/buttons/IconButtons';
import Constants from 'utils/Constants';

const NavItem = (props) => {
  let selectedStyle = {
    backgroundColor: 'rgba(9, 155, 250, 0.05)',
    borderRight: '2px solid #099BFA',
    paddingLeft: '10px'
  }
  let regStyle = {
    paddingLeft: '10px'
  }
  return (
    <div
      className={styles.iconLine}
      style={(props.selectedView === Constants.view[props.itemType]) ? selectedStyle : regStyle}
      onClick={() => { props.changeView('main') }}>
        { Constants.view[props.itemType] === Constants.view.main &&
          <NavMain style={{flexShrink: '0', flexGrow: '0'}} color={(props.selectedView === Constants.view.main) ? "#099BFA" : "#CCCCCC"} />
        }
        { Constants.view[props.itemType] === Constants.view.comparison &&
          <NavComparison style={{flexShrink: '0', flexGrow: '0'}} color={(props.selectedView === Constants.view.comparison) ? "#099BFA" : "#CCCCCC"} />
        }
        { Constants.view[props.itemType] === Constants.view.table &&
          <NavTable style={{flexShrink: '0', flexGrow: '0'}} color={(props.selectedView === Constants.view.table) ? "#099BFA" : "#CCCCCC"} />
        }
        <h5
          onClick={() => { props.changeView('main') }}
          style={{
            height: '26px',
            overflow: 'hidden',
            color: (props.selectedView === Constants.view[props.itemType]) ? "#666666" : "#CCCCCC",
            opacity: (props.navBarOpen) ? "1" : "0",
            maxWidth: (props.navBarOpen) ? "none" : "0"
          }}
        >
          {props.label}
        </h5>
    </div>
  )
}

export default NavItem;
//selectedView
// changeView
// navBarOpen
// label



// WEBPACK FOOTER //
// ./src/scripts/components/navigation/NavItem.js